import { render, staticRenderFns } from "./CrGLTransactionList.vue?vue&type=template&id=0cb69b52&"
import script from "./CrGLTransactionList.vue?vue&type=script&lang=js&"
export * from "./CrGLTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./CrGLTransactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports